'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t;

import PropTypes from 'prop-types';
import styled from 'styled-components';
import UIImage from 'UIComponents/image/UIImage';
import UIBadge from 'UIComponents/badge/UIBadge';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ProductLinePageIcons } from 'ui-addon-upgrades/_core/productPage/ProductPageIcons';
import breakpoint from '../../utils/responsiveBreakpoints';
import * as ProductLines from 'self-service-api/constants/ProductLines';
import { useSelector } from 'react-redux';
import { isMon569VariantSelector } from '../../selectors/ExperimentTreatmentSelectors';
const HubTitle = styled.div.withConfig({
  displayName: "StandardProductPageTitle__HubTitle",
  componentId: "ki0hl0-0"
})(["color:#33475b;font-size:", ";font-weight:600;text-align:center;margin:", ";display:flex;justify-content:", ";align-items:center;min-height:44px;", ";"], ({
  size
}) => size === 'small' ? '26px' : '32px', ({
  isMon569Variant
}) => isMon569Variant ? '0 0 10px' : '0 auto 10px', ({
  isMon569Variant
}) => isMon569Variant ? 'start' : 'center', breakpoint.cs(_t || (_t = _`
    margin-top: 0;
    justify-content: center;
  `)));
const Trademark = styled.span.withConfig({
  displayName: "StandardProductPageTitle__Trademark",
  componentId: "ki0hl0-1"
})(["font-weight:200;font-size:70%;"]);

const StandardProductPageTitle = (_ref) => {
  let {
    productLine,
    size,
    isNew,
    includeTrademark,
    includeRegisteredTrademark,
    showIcon,
    isCrmSuite
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["productLine", "size", "isNew", "includeTrademark", "includeRegisteredTrademark", "showIcon", "isCrmSuite"]);

  const copyMap = {
    [ProductLines.MARKETING]: 'pricingPage.pages.products.tabs.marketing.pageTitle',
    [ProductLines.CMS]: 'pricingPage.pages.products.tabs.cmsHub.pageTitle',
    [ProductLines.SALES]: 'pricingPage.pages.products.tabs.sales.pageTitle',
    [ProductLines.SERVICE]: 'pricingPage.pages.products.tabs.service.pageTitle',
    [ProductLines.OPERATIONS]: 'pricingPage.pages.products.tabs.operations.pageTitle',
    crmSuite: 'pricingPage.pages.products.tabs.crmSuite.pageTitle'
  };
  const isMon569Variant = useSelector(isMon569VariantSelector);
  const stringKey = isCrmSuite ? copyMap['crmSuite'] : productLine ? copyMap[productLine] : 'pricingPage.pages.products.tabs.crm.pageTitle';
  return /*#__PURE__*/_jsxs(HubTitle, Object.assign({
    size: size,
    isMon569Variant: isMon569Variant
  }, rest, {
    children: [showIcon && productLine && /*#__PURE__*/_jsx(UIImage, {
      className: "display-inline m-right-3",
      src: ProductLinePageIcons[productLine]
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: stringKey
    }), includeTrademark && /*#__PURE__*/_jsx(Trademark, {
      children: "\u2122"
    }), includeRegisteredTrademark && /*#__PURE__*/_jsx(Trademark, {
      children: "\xAE"
    }), isMon569Variant && /*#__PURE__*/_jsx(FormattedMessage, {
      className: "m-left-2",
      message: "mon569.pricing"
    }), isNew && /*#__PURE__*/_jsx(UIBadge, {
      use: "new",
      className: "m-left-3",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.new"
      })
    })]
  }));
};

StandardProductPageTitle.propTypes = {
  productLine: PropTypes.string,
  size: PropTypes.oneOf(['default', 'small']),
  isNew: PropTypes.bool,
  includeTrademark: PropTypes.bool,
  includeRegisteredTrademark: PropTypes.bool,
  showIcon: PropTypes.bool,
  isCrmSuite: PropTypes.bool
};
StandardProductPageTitle.defaultProps = {
  size: 'default',
  isNew: false,
  includeTrademark: false,
  includeRegisteredTrademark: false,
  showIcon: true,
  isCrmSuite: false
};
export default StandardProductPageTitle;